<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой (!!) -->
		
		<template #curveName>Эпициклоида</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
			
			<!-- Геометрическое место точек -->
			
			<h5 class="mt-0">
				Геометрическое место точек:
			</h5>
			<img src="@/assets/img/epicycloid_gmt.gif" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Эпициклоида</strong>
				- траектория точки <vue-mathjax :formula="viewExpression('M')" class="formula"></vue-mathjax>, принадлежащий
				окружности радиуса <vue-mathjax :formula="viewExpression('a')" class="formula"></vue-mathjax>,
				которая катится по внешней стороне окружности
				<vue-mathjax :formula="viewExpression('x^{2} + y^{2} = b^{2}')" class="formula"></vue-mathjax>,
				(в начальный момент точка <vue-mathjax :formula="viewExpression('M')" class="formula"></vue-mathjax> равна
				точке <vue-mathjax :formula="viewExpression('M_{0} (b, 0)')" class="formula"></vue-mathjax>)
			</p>
			
			<h5>Параметрическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<!--
				Параметры ползунка для выбора ОДЗ параметра (!!)
				min - минимальная левая граница
				max - максимальная правая граница
				interval - шаг, с которым можно выбирать
				Для того, чтобы блокировать точки используй
				:dot-options="tDotOptions" для тега
				tDotOptions: [{            для data()
          disabled: false
        }, {
          disabled: true
        }]
			-->
			<vue-slider
					v-model="t"
					:min="-20"
					:max="20"
					:interval="0.1"
					@dragging="drawLine"
			></vue-slider>
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов (!!) -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<!--
				Параметры для выбора коэффициентов (!!)
				min - минимальное значение коэффициента
				max - максимальное значение коэффициента
				step - шаг, с которым можно выбирать
				disabled - если нужно заблокировать выбор
			-->
			
			<b-form-spinbutton
					v-model="a"
					:min="-30"
					:max="30"
					:step="1"
					@input="drawLine"
					vertical
					class="curve__coef"
			></b-form-spinbutton>
			
			<!-- Коэффициент b -->
			
			<label>
				<vue-mathjax :formula="coefficientB" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton
					v-model="b"
					:min="-30"
					:max="30"
					:step="1"
					@input="drawLine"
					vertical
					class="curve__coef"
			></b-form-spinbutton>
			
			<p v-if="(a !== 0) && (a === b)">Этот частный случай называют <i>Кардиоидой</i>. <br><a href="/cardioid">Изучить подробнее...</a></p>
			
		</template>
		
		<!-- модуль Информация о кривой -->
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<div>
			<div class="info__picture">
			<a href="https://ru.wikipedia.org/wiki/%D0%93%D0%B8%D0%BF%D0%BF%D0%B0%D1%80%D1%85"><img src="@/assets/img/epicycloid_info_giparch.jpg" width="100" alt="Гиппарх"></a>
			</div>
			<div class="info__picture">
			<a href="https://ru.wikipedia.org/wiki/%D0%94%D1%8E%D1%80%D0%B5%D1%80,_%D0%90%D0%BB%D1%8C%D0%B1%D1%80%D0%B5%D1%85%D1%82"><img src="@/assets/img/epicycloid_info_durer.jpg" width="100" alt="Дюрер"></a>
			</div>
			<div class="info__picture">
			<a href="https://ru.wikipedia.org/wiki/%D0%94%D0%B5%D0%B7%D0%B0%D1%80%D0%B3,_%D0%96%D0%B5%D1%80%D0%B0%D1%80"><img src="@/assets/img/epicycloid_info_dezarg.jpeg" width="100" alt="Дезарг"></a>
			</div>
			</div>
		</template>
		
		<!-- Контент -->
		
		<template #curveInfo>
			<h5 class="mt-0">История</h5>
			<p>Чтобы объяснить попятные движения планет, древнегреческие астрономы, следуя <i><b>Гиппарху</b></i> (II в. до н.э.),
				приписывали им равномерное движение по окружности (эпицикл), центр которой равномерно движется по другой
				окружности (деферент). Линия, описываемая точкой при этих условиях, является эпициклоидой.</p>
			<p>Начало систематического изучения эпициклоид и гипоциклоид было положено в 1525 г. знаменитым немецким художником
				<i><b>Альбрехтом Дюрером</b></i> (1471–1528). Он широко применял геометрические методы в изобразительном искусстве.
				Однако математикам исследования Дюрера остались неизвестными.</p>
			<p>В середине XVII века <i><b>Ж.Дезарг</b></i> (1593–1662) изучал свойства эпициклоид в связи с задачей создания зубчатых колес
				с наименьшим трением. <i><b>Ла Гир</b></i>, продолживший исследования Дезарга, опубликовал в 1675 г.
				“Трактат об эпициклоидах и их применении в механике”. Здесь установлен ряд важных свойств эпициклоид.</p>
			<h5>В природе</h5>
			<p>Расположение лепестков цветка орхидей напоминает кривую эпициклоиды:</p>
			<img src="@/assets/img/epicycloid_info_nature.jpg" class="info__picture info__nature">
		
			<!--
			https://ru.wikipedia.org/wiki/%D0%AD%D0%BF%D0%B8%D1%86%D0%B8%D0%BA%D0%BB%D0%BE%D0%B8%D0%B4%D0%B0
			https://sites.google.com/site/mircurves/epicikloidy-i-gipocikloidy
			-->
		</template>
		
		<!-- модуль Задачи -->
		
		<template #curveTasks>
			<h5 class="mt-0">Примеры задач:</h5>
		</template>
	
	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'Epicycloid',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения (!!) */
				a: 0,
				b: 0,
				/* ОДЗ параметра (!!) */
				t: [0, 2]
			}
		},
		computed: {
			/* Функции для представления в latex (!!)
			 * equationInPolar - Уравнение в полярных координатах
			 * equationInCartesian - Аналитическое уравнение
			 * equationParamInCartesian - Параметрическое уравнение
			  * */
			equationParamInCartesian: () => {
				return '$$ \\begin{cases}x=(a + b)\\cos t - a \\cos \\frac {a + b}{a} t \\\\ y=(a + b)\\sin t - a \\sin \\frac {a + b}{a} t \\end{cases} $$';
			},
			/**
			 * ОДЗ (!!)
			 * Свойства возвращают реальные границы для параметра t
			 * (в том случае, если границы, выбираемые ползунком нужно преобразовать)
			 * Пример: значения определённые ползунком [0, 2], но реальные границы 0 * pi < t < 2 * pi
			 * minTheta - левая граница
			 * maxTheta - правая граница
			 * rangeODZ - представление
			 * */
			rangeODZ: (context) => {
				return '$$ ' + context.t[0] +  ' \\pi < t <' + context.t[1] + ' \\pi $$';
			},
			maxTheta: ({ t }) => {
				return t[1] * Math.PI;
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI;
			}
		},
		methods: {
			/**
			 * (!!)
			 * Возвращает значение x при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			X (t) {
				return 160 + ((this.a + this.b) * Math.cos(t) - this.a * Math.cos(((this.a + this.b) * t) / this.a)) * this.$store.state.step;
			},
			/**
			 * (!!)
			 * Возвращает значение y при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			Y (t) {
				return 160 + ((this.a + this.b) * Math.sin(t) - this.a * Math.sin(((this.a + this.b) * t) / this.a)) * this.$store.state.step;
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
